export const categories = [
  {
    slug: 'sousuo-jiqiao',
    name: '搜索技巧',
    icon: 'ri-search-eye-line',
    description: '掌握高级搜索语法，精准定位目标视频资源，提升查找效率',
    color: 'accent',
  },
  {
    slug: 'fenlei-liulan',
    name: '分类浏览',
    icon: 'ri-grid-line',
    description: '了解平台分类体系，按频道、标签、排行榜高效浏览内容',
    color: 'primary',
  },
  {
    slug: 'gaoqing-xiazai',
    name: '高清下载',
    icon: 'ri-download-cloud-line',
    description: '多分辨率选择、批量下载技巧，稳定获取高清无水印视频',
    color: 'accent',
  },
  {
    slug: 'shoucang-guanli',
    name: '收藏管理',
    icon: 'ri-bookmark-line',
    description: '建立收藏夹体系，标签分类整理，实现高效内容管理与回溯',
    color: 'primary',
  },
  {
    slug: 'xinren-rumen',
    name: '新手入门',
    icon: 'ri-rocket-line',
    description: '从注册账号到基础操作，一站式带你快速上手P站视频',
    color: 'accent',
  },
  {
    slug: 'jinjie-jiqiao',
    name: '进阶技巧',
    icon: 'ri-flashlight-line',
    description: '解锁隐藏功能、快捷键操作、RSS订阅等高级使用技巧',
    color: 'primary',
  },
];